<template>
	<div class="badge" :class="theme">
		<slot></slot>
	</div>
</template>

<script setup>
// eslint-disable-next-line no-undef
defineProps({
	theme: {
		type: String,
		default: 'default'
	}
})
</script>

<style lang="scss" scoped>
.badge {
	border-radius: 4px;
	font-size: 0.715rem;
	display: inline-block;
	padding: 0.2rem 0.4rem;
	letter-spacing: 0.92px;
	text-transform: uppercase;
	font-weight: bold;

	&.default {
		background-color: #eca58f;
		color: #fff;
	}

	&.primary {
		background-color: #7d8bf7;
		color: #fff;
	}
}
</style>
